"use strict";
///
/// This file contains enums that are used by the DB schemas and also have to appear in API contracts that the
/// front end uses. These enums will end up in the frontend bundle.
///
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoPrizeRewardRefKey = exports.PromoPrizeRewardStatus = exports.EmailState = exports.TokenOrderStatus = exports.TokenRedemptionStatus = exports.PrizeWinStatus = exports.TaskStatus = exports.TaskQueueType = exports.ScheduledTaskStatus = exports.ProductType = exports.ProductStatus = exports.PrizeTierType = exports.VendorCategory = exports.PrizeType = exports.PrizeOrderStatus = exports.SubscriptionStatus = exports.RewardType = exports.AuditAction = exports.GiveawayType = exports.PromoRecurringStatus = exports.TokenRedemptionOptionStatus = exports.TokenRedemptionOptionGroup = exports.PromoAction = exports.TokenRedemptionOptionType = exports.WinType = exports.PlayerStatus = exports.PromoStatus = exports.PromoType = exports.PrizeStatus = exports.PrizeDisplayGroup = exports.TicketStatus = exports.SubscriptionRunStatus = exports.DrawOrderStatus = exports.OrderStatus = exports.AdyenSessionAction = exports.TransactionType = exports.PaymentRefType = exports.PaymentStatus = exports.GameType = exports.PaymentCurrency = exports.PaymentMethod = exports.TreeRefKey = exports.TreeStatus = exports.TreeAction = exports.DrawStatus = exports.DrawScheduleStatus = exports.FeedbackRefKey = exports.FeedbackAction = exports.PurchasingAction = exports.LeaderboardAction = void 0;
exports.ReferralStatus = exports.ReferralScheme = void 0;
var LeaderboardAction;
(function (LeaderboardAction) {
    LeaderboardAction["TRUSTPILOT_REVIEW"] = "TRUSTPILOT_REVIEW";
    LeaderboardAction["FACEBOOK_REVIEW"] = "FACEBOOK_REVIEW";
    LeaderboardAction["GOOGLE_REVIEW"] = "GOOGLE_REVIEW";
    LeaderboardAction["INSTAGRAM_FOLLOW"] = "INSTAGRAM_FOLLOW";
    LeaderboardAction["MAILING_LIST_BONUS"] = "MAILING_LIST_BONUS";
    LeaderboardAction["AJ385_SURVEY"] = "AJ385_SURVEY";
    LeaderboardAction["SUGGEST_PRIZE"] = "SUGGEST_PRIZE";
    LeaderboardAction["REFER_FRIEND_TOKEN_REWARD"] = "REFER_FRIEND_TOKEN_REWARD";
    LeaderboardAction["REFER_FRIEND"] = "REFER_FRIEND";
    LeaderboardAction["ENTER_DAILY_CHALLENGER"] = "ENTER_DAILY_CHALLENGER";
    LeaderboardAction["VIDEO_TESTIMONIAL"] = "VIDEO_TESTIMONIAL";
    LeaderboardAction["EXCHANGE_TOKEN"] = "EXCHANGE_TOKEN";
    LeaderboardAction["GENERIC_BONUS"] = "GENERIC_BONUS";
    LeaderboardAction["WEEKLY_DRAW_FREEMIUM"] = "WEEKLY_DRAW_FREEMIUM";
    LeaderboardAction["LOTTERY_ENTRY"] = "LOTTERY_ENTRY";
    LeaderboardAction["RAFFLE_ENTRY"] = "RAFFLE_ENTRY";
    LeaderboardAction["DAILY_POUND_RAFFLE"] = "DAILY_POUND_RAFFLE";
    LeaderboardAction["SUBSCRIBER_BONUS"] = "SUBSCRIBER_BONUS";
    LeaderboardAction["TRUSTPILOT_REVIEW_CARRIED_OVER"] = "TRUSTPILOT_REVIEW_CARRIED_OVER";
    LeaderboardAction["FACEBOOK_REVIEW_CARRIED_OVER"] = "FACEBOOK_REVIEW_CARRIED_OVER";
    LeaderboardAction["GOOGLE_REVIEW_CARRIED_OVER"] = "GOOGLE_REVIEW_CARRIED_OVER";
    LeaderboardAction["INSTAGRAM_FOLLOW_CARRIED_OVER"] = "INSTAGRAM_FOLLOW_CARRIED_OVER";
    LeaderboardAction["SUBSCRIBER_BONUS_CARRIED_OVER"] = "SUBSCRIBER_BONUS_CARRIED_OVER";
})(LeaderboardAction || (exports.LeaderboardAction = LeaderboardAction = {}));
var PurchasingAction;
(function (PurchasingAction) {
    PurchasingAction["GOODWILL"] = "GOODWILL";
    PurchasingAction["POSTAL"] = "POSTAL";
    PurchasingAction["PRIZE"] = "PRIZE";
    PurchasingAction["PROMO"] = "PROMO";
    PurchasingAction["PURCHASE_TOKEN"] = "PURCHASE_TOKEN";
    PurchasingAction["REDEEM_TOKEN"] = "REDEEM_TOKEN";
    PurchasingAction["REFERRAL"] = "REFERRAL";
    PurchasingAction["REWARD"] = "REWARD";
    PurchasingAction["SUBSCRIPTION"] = "SUBSCRIPTION";
    PurchasingAction["SUBSCRIPTION_UPGRADE"] = "SUBSCRIPTION_UPGRADE";
    PurchasingAction["SUBSCRIPTION_INITIAL"] = "SUBSCRIPTION_INITIAL";
    PurchasingAction["WINNER_CONTENT"] = "WINNER_CONTENT";
    PurchasingAction["LEADERBOARD"] = "LEADERBOARD";
})(PurchasingAction || (exports.PurchasingAction = PurchasingAction = {}));
var FeedbackAction;
(function (FeedbackAction) {
    FeedbackAction["CLAIM_PRIZE_WIN"] = "CLAIM_PRIZE_WIN";
    FeedbackAction["CANCEL_SUBSCRIPTION"] = "CANCEL_SUBSCRIPTION";
    FeedbackAction["TOKEN_TOWN"] = "TOKEN_TOWN";
    FeedbackAction["SUGGEST_PRIZE"] = "SUGGEST_PRIZE";
})(FeedbackAction || (exports.FeedbackAction = FeedbackAction = {}));
var FeedbackRefKey;
(function (FeedbackRefKey) {
    FeedbackRefKey["prizeWin"] = "prize_win";
    FeedbackRefKey["subscription"] = "subscription";
    FeedbackRefKey["noKey"] = "no_key";
})(FeedbackRefKey || (exports.FeedbackRefKey = FeedbackRefKey = {}));
var DrawScheduleStatus;
(function (DrawScheduleStatus) {
    DrawScheduleStatus["ACTIVE"] = "ACTIVE";
    DrawScheduleStatus["DISABLED"] = "DISABLED";
})(DrawScheduleStatus || (exports.DrawScheduleStatus = DrawScheduleStatus = {}));
var DrawStatus;
(function (DrawStatus) {
    DrawStatus["SCHEDULED"] = "SCHEDULED";
    DrawStatus["INPROGRESS"] = "INPROGRESS";
    DrawStatus["RESULTED"] = "RESULTED";
    DrawStatus["AWARDING"] = "AWARDING";
    DrawStatus["PRIZES_AWARDED"] = "PRIZES_AWARDED";
    DrawStatus["COMPLETED"] = "COMPLETED";
    DrawStatus["CANCELLED"] = "CANCELLED";
})(DrawStatus || (exports.DrawStatus = DrawStatus = {}));
// Define enums for action and ref_key constraints
var TreeAction;
(function (TreeAction) {
    TreeAction["INITIAL_ENTRY"] = "INITIAL_ENTRY";
    TreeAction["TOKEN_EXCHANGE_TREE"] = "TOKEN_EXCHANGE_TREE";
    TreeAction["FREE_ENTRY_AND_EXTRA_TREE"] = "FREE_ENTRY_AND_EXTRA_TREE";
    TreeAction["TICKET_PURCHASE"] = "TICKET_PURCHASE";
    TreeAction["TREAT_EXCHANGED_TREE"] = "TREAT_EXCHANGED_TREE";
    TreeAction["SUBSCRIPTION_RENEWAL"] = "SUBSCRIPTION_RENEWAL";
    TreeAction["GIFT_CARD"] = "GIFT_CARD";
    TreeAction["TOKEN_ORDER"] = "TOKEN_ORDER";
    TreeAction["ACCOUNT_MERGE"] = "ACCOUNT_MERGE";
})(TreeAction || (exports.TreeAction = TreeAction = {}));
var TreeStatus;
(function (TreeStatus) {
    TreeStatus["PENDING"] = "PENDING";
    TreeStatus["CONFIRMED"] = "CONFIRMED";
})(TreeStatus || (exports.TreeStatus = TreeStatus = {}));
var TreeRefKey;
(function (TreeRefKey) {
    TreeRefKey["player"] = "player";
    TreeRefKey["leaderboard_contribution"] = "leaderboard_contribution";
    TreeRefKey["token_redemption"] = "token_redemption";
    TreeRefKey["gift_card"] = "gift_card";
    TreeRefKey["subscription"] = "subscription";
    TreeRefKey["prize_order_product"] = "prize_order_product";
    TreeRefKey["ticket_order"] = "ticket_order";
    TreeRefKey["ticket"] = "ticket";
    TreeRefKey["order"] = "order";
})(TreeRefKey || (exports.TreeRefKey = TreeRefKey = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["ADYEN"] = "ADYEN";
    PaymentMethod["PAYPAL"] = "PAYPAL";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var PaymentCurrency;
(function (PaymentCurrency) {
    PaymentCurrency["GBP"] = "GBP";
    PaymentCurrency["TOKEN"] = "TOKEN";
})(PaymentCurrency || (exports.PaymentCurrency = PaymentCurrency = {}));
var GameType;
(function (GameType) {
    GameType["LOTTERY"] = "LOTTERY";
    GameType["RAFFLE"] = "RAFFLE";
    GameType["BIG_RAFFLE"] = "BIG_RAFFLE";
    GameType["LEADERBOARD"] = "LEADERBOARD";
})(GameType || (exports.GameType = GameType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["SENT"] = "SENT";
    PaymentStatus["APPROVED"] = "APPROVED";
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["REFUNDED"] = "REFUNDED";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var PaymentRefType;
(function (PaymentRefType) {
    PaymentRefType["ORDER"] = "ORDER";
    PaymentRefType["SUBSCRIPTION"] = "SUBSCRIPTION";
    PaymentRefType["INVITEDBY"] = "INVITEDBY";
    PaymentRefType["PRIZE_ORDER_PRODUCT"] = "PRIZE_ORDER_PRODUCT";
    PaymentRefType["GIVEAWAY"] = "GIVEAWAY";
    PaymentRefType["TOKEN_REDEMPTION"] = "TOKEN_REDEMPTION";
    PaymentRefType["TICKET_REFUND"] = "TICKET_REFUND";
    PaymentRefType["GIFT_CARD_ORDER"] = "GIFT_CARD_ORDER";
    PaymentRefType["MIGRATION"] = "MIGRATION";
    PaymentRefType["MANUAL_ADJUSTMENT"] = "MANUAL_ADJUSTMENT";
})(PaymentRefType || (exports.PaymentRefType = PaymentRefType = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["CREDIT"] = "CREDIT";
    TransactionType["DEBIT"] = "DEBIT";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var AdyenSessionAction;
(function (AdyenSessionAction) {
    AdyenSessionAction["ORDER"] = "ORDER";
    AdyenSessionAction["RECURRING"] = "RECURRING";
    AdyenSessionAction["CHANGEPAYMENTMETHOD"] = "CHANGEPAYMENTMETHOD";
    AdyenSessionAction["REFUND"] = "REFUND";
})(AdyenSessionAction || (exports.AdyenSessionAction = AdyenSessionAction = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["COMPLETED"] = "COMPLETED";
    OrderStatus["CANCELLED"] = "CANCELLED";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var DrawOrderStatus;
(function (DrawOrderStatus) {
    DrawOrderStatus["ACTIVE"] = "ACTIVE";
    DrawOrderStatus["DELETED"] = "DELETED";
})(DrawOrderStatus || (exports.DrawOrderStatus = DrawOrderStatus = {}));
var SubscriptionRunStatus;
(function (SubscriptionRunStatus) {
    SubscriptionRunStatus["PENDING"] = "PENDING";
    SubscriptionRunStatus["FAILING"] = "FAILING";
    SubscriptionRunStatus["FAILED"] = "FAILED";
    SubscriptionRunStatus["COMPLETED"] = "COMPLETED";
})(SubscriptionRunStatus || (exports.SubscriptionRunStatus = SubscriptionRunStatus = {}));
var TicketStatus;
(function (TicketStatus) {
    TicketStatus["PLACED"] = "PLACED";
    TicketStatus["RESULTED"] = "RESULTED";
    TicketStatus["CANCELLED"] = "CANCELLED";
})(TicketStatus || (exports.TicketStatus = TicketStatus = {}));
var PrizeDisplayGroup;
(function (PrizeDisplayGroup) {
    PrizeDisplayGroup["HERO"] = "HERO";
    PrizeDisplayGroup["TRENDING"] = "TRENDING";
    PrizeDisplayGroup["TOP"] = "TOP";
    PrizeDisplayGroup["LAST"] = "LAST";
})(PrizeDisplayGroup || (exports.PrizeDisplayGroup = PrizeDisplayGroup = {}));
var PrizeStatus;
(function (PrizeStatus) {
    PrizeStatus["VISIBLE"] = "VISIBLE";
    PrizeStatus["HIDDEN"] = "HIDDEN";
})(PrizeStatus || (exports.PrizeStatus = PrizeStatus = {}));
var PromoType;
(function (PromoType) {
    PromoType["REFERRAL"] = "REFERRAL";
    PromoType["PROMO"] = "PROMO";
    PromoType["SYSTEM"] = "SYSTEM";
})(PromoType || (exports.PromoType = PromoType = {}));
var PromoStatus;
(function (PromoStatus) {
    PromoStatus["PENDING"] = "PENDING";
    PromoStatus["ACTIVE"] = "ACTIVE";
    PromoStatus["SUSPENDED"] = "SUSPENDED";
})(PromoStatus || (exports.PromoStatus = PromoStatus = {}));
var PlayerStatus;
(function (PlayerStatus) {
    PlayerStatus["ACTIVE"] = "ACTIVE";
    PlayerStatus["CLOSED"] = "CLOSED";
    PlayerStatus["CONTACT_ONLY"] = "CONTACT_ONLY";
    PlayerStatus["GUEST"] = "GUEST";
    PlayerStatus["SUSPENDED"] = "SUSPENDED";
})(PlayerStatus || (exports.PlayerStatus = PlayerStatus = {}));
var WinType;
(function (WinType) {
    WinType["PRIZE"] = "PRIZE";
    WinType["TREAT"] = "TREAT";
})(WinType || (exports.WinType = WinType = {}));
var TokenRedemptionOptionType;
(function (TokenRedemptionOptionType) {
    TokenRedemptionOptionType["PRIZE"] = "PRIZE";
    TokenRedemptionOptionType["ENTRY"] = "ENTRY";
    TokenRedemptionOptionType["TREE"] = "TREE";
})(TokenRedemptionOptionType || (exports.TokenRedemptionOptionType = TokenRedemptionOptionType = {}));
var PromoAction;
(function (PromoAction) {
    PromoAction["SUBSCRIPTION_PURCHASE"] = "SUBSCRIPTION_PURCHASE";
    PromoAction["LEGACY"] = "LEGACY";
})(PromoAction || (exports.PromoAction = PromoAction = {}));
var TokenRedemptionOptionGroup;
(function (TokenRedemptionOptionGroup) {
    TokenRedemptionOptionGroup["GAME"] = "GAME";
    TokenRedemptionOptionGroup["PRIZE"] = "PRIZE";
})(TokenRedemptionOptionGroup || (exports.TokenRedemptionOptionGroup = TokenRedemptionOptionGroup = {}));
var TokenRedemptionOptionStatus;
(function (TokenRedemptionOptionStatus) {
    TokenRedemptionOptionStatus["VISIBLE"] = "VISIBLE";
    TokenRedemptionOptionStatus["HIDDEN"] = "HIDDEN";
})(TokenRedemptionOptionStatus || (exports.TokenRedemptionOptionStatus = TokenRedemptionOptionStatus = {}));
var PromoRecurringStatus;
(function (PromoRecurringStatus) {
    PromoRecurringStatus["COMPLETE"] = "COMPLETE";
    PromoRecurringStatus["INPROGRESS"] = "INPROGRESS";
    PromoRecurringStatus["CANCELLED"] = "CANCELLED";
})(PromoRecurringStatus || (exports.PromoRecurringStatus = PromoRecurringStatus = {}));
var GiveawayType;
(function (GiveawayType) {
    GiveawayType["ENTRY"] = "ENTRY";
    GiveawayType["TOKEN"] = "TOKEN";
    GiveawayType["POINT"] = "POINT";
    GiveawayType["GIFTCARD"] = "GIFTCARD";
})(GiveawayType || (exports.GiveawayType = GiveawayType = {}));
var AuditAction;
(function (AuditAction) {
    AuditAction["INSERT"] = "INSERT";
    AuditAction["UPDATE"] = "UPDATE";
    AuditAction["DELETE"] = "DELETE";
})(AuditAction || (exports.AuditAction = AuditAction = {}));
/** RewardType, as used by promo codes */
var RewardType;
(function (RewardType) {
    RewardType["DISCOUNT_PERCENTAGE"] = "DISCOUNT_PERCENTAGE";
    RewardType["DISCOUNT_ENTRY"] = "DISCOUNT_ENTRY";
    RewardType["FIXED_DISCOUNT"] = "FIXED_DISCOUNT";
    RewardType["FREE_ENTRY"] = "FREE_ENTRY";
    RewardType["LEGACY"] = "LEGACY";
})(RewardType || (exports.RewardType = RewardType = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["PENDING"] = "PENDING";
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["INACTIVE"] = "INACTIVE";
    SubscriptionStatus["SNOOZED"] = "SNOOZED";
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
    SubscriptionStatus["FAILING"] = "FAILING";
    SubscriptionStatus["FAILED"] = "FAILED";
})(SubscriptionStatus || (exports.SubscriptionStatus = SubscriptionStatus = {}));
var PrizeOrderStatus;
(function (PrizeOrderStatus) {
    PrizeOrderStatus["PENDING"] = "PENDING";
    PrizeOrderStatus["NEW"] = "NEW";
    PrizeOrderStatus["OPEN"] = "OPEN";
    PrizeOrderStatus["PROCESSING"] = "PROCESSING";
    PrizeOrderStatus["ON_HOLD"] = "ON_HOLD";
    PrizeOrderStatus["CANCELLED"] = "CANCELLED";
    PrizeOrderStatus["ORDER_DOWNLOADED"] = "ORDER_DOWNLOADED";
    PrizeOrderStatus["CONFIRMED"] = "CONFIRMED";
})(PrizeOrderStatus || (exports.PrizeOrderStatus = PrizeOrderStatus = {}));
var PrizeType;
(function (PrizeType) {
    PrizeType["SINGLE"] = "SINGLE";
    PrizeType["OPTION"] = "OPTION";
    PrizeType["MULTI_OPTION"] = "MULTI_OPTION";
    PrizeType["BUNDLE"] = "BUNDLE";
    PrizeType["BESPOKE"] = "BESPOKE";
})(PrizeType || (exports.PrizeType = PrizeType = {}));
var VendorCategory;
(function (VendorCategory) {
    VendorCategory["BIG_BRAND"] = "BIG_BRAND";
    VendorCategory["GOOD_CAUSES"] = "GOOD_CAUSES";
    VendorCategory["SMALL_MEDIUM"] = "SMALL_MEDIUM";
})(VendorCategory || (exports.VendorCategory = VendorCategory = {}));
var PrizeTierType;
(function (PrizeTierType) {
    PrizeTierType["MATERIAL"] = "MATERIAL";
    PrizeTierType["IN_GAME"] = "IN_GAME";
})(PrizeTierType || (exports.PrizeTierType = PrizeTierType = {}));
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["AVAILABLE"] = "AVAILABLE";
    ProductStatus["UNAVAILABLE"] = "UNAVAILABLE";
    ProductStatus["DISCONTINUED"] = "DISCONTINUED";
})(ProductStatus || (exports.ProductStatus = ProductStatus = {}));
var ProductType;
(function (ProductType) {
    ProductType["PHYSICAL"] = "PHYSICAL";
    ProductType["DONATION"] = "DONATION";
    ProductType["ENTRY"] = "ENTRY";
    ProductType["CREDIT"] = "CREDIT";
    ProductType["GIFTCARD"] = "GIFTCARD";
    ProductType["PLACEHOLDER_MULTI_OPTION"] = "PLACEHOLDER_MULTI_OPTION";
    ProductType["PLACEHOLDER_LEGACY"] = "PLACEHOLDER_LEGACY";
})(ProductType || (exports.ProductType = ProductType = {}));
var ScheduledTaskStatus;
(function (ScheduledTaskStatus) {
    ScheduledTaskStatus["ENABLED"] = "ENABLED";
    ScheduledTaskStatus["DISABLED"] = "DISABLED";
})(ScheduledTaskStatus || (exports.ScheduledTaskStatus = ScheduledTaskStatus = {}));
var TaskQueueType;
(function (TaskQueueType) {
    TaskQueueType["GENERAL"] = "GENERAL";
    TaskQueueType["SUBSCRIPTION"] = "SUBSCRIPTION";
    TaskQueueType["RESULTING"] = "RESULTING";
    TaskQueueType["LONG_RUNNING"] = "LONG_RUNNING";
})(TaskQueueType || (exports.TaskQueueType = TaskQueueType = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["PENDING"] = "PENDING";
    TaskStatus["QUEUED"] = "QUEUED";
    TaskStatus["PROCESSING"] = "PROCESSING";
    TaskStatus["DONE"] = "DONE";
    TaskStatus["FAILED"] = "FAILED";
})(TaskStatus || (exports.TaskStatus = TaskStatus = {}));
/**
 * @readonly
 * @enum {string}
 * @property {string} PENDING Player has won a prize but has not yet been selected
 * @property {string} AWARDED CS Team has sent the prize to the player
 * @property {string} CHOSEN Player has selected a prize or pre-selected due to raffle type
 * @property {string} AWAITING_RESELECTION Player has chosen a prize, but there was an issue with their order, therefore allowed to reselect
 */
var PrizeWinStatus;
(function (PrizeWinStatus) {
    PrizeWinStatus["PENDING"] = "PENDING";
    PrizeWinStatus["AWARDED"] = "AWARDED";
    PrizeWinStatus["CHOSEN"] = "CHOSEN";
    PrizeWinStatus["AWAITING_RESELECTION"] = "AWAITING_RESELECTION";
    PrizeWinStatus["CANCELLED"] = "CANCELLED";
})(PrizeWinStatus || (exports.PrizeWinStatus = PrizeWinStatus = {}));
var TokenRedemptionStatus;
(function (TokenRedemptionStatus) {
    TokenRedemptionStatus["PENDING"] = "PENDING";
    TokenRedemptionStatus["COMPLETED"] = "COMPLETED";
    TokenRedemptionStatus["CANCELLED"] = "CANCELLED";
})(TokenRedemptionStatus || (exports.TokenRedemptionStatus = TokenRedemptionStatus = {}));
var TokenOrderStatus;
(function (TokenOrderStatus) {
    TokenOrderStatus["PENDING"] = "PENDING";
    TokenOrderStatus["COMPLETED"] = "COMPLETED";
    TokenOrderStatus["CANCELLED"] = "CANCELLED";
})(TokenOrderStatus || (exports.TokenOrderStatus = TokenOrderStatus = {}));
var EmailState;
(function (EmailState) {
    EmailState["PENDING"] = "PENDING";
    EmailState["OPENED"] = "OPENED";
    EmailState["CLICKED"] = "CLICKED";
    EmailState["SENT"] = "SENT";
    EmailState["SENT_FROM_BREVO"] = "SENT_FROM_BREVO";
})(EmailState || (exports.EmailState = EmailState = {}));
var PromoPrizeRewardStatus;
(function (PromoPrizeRewardStatus) {
    PromoPrizeRewardStatus["PENDING"] = "PENDING";
    PromoPrizeRewardStatus["CHOSEN"] = "CHOSEN";
    PromoPrizeRewardStatus["AWARDED"] = "AWARDED";
    PromoPrizeRewardStatus["CANCELLED"] = "CANCELLED";
})(PromoPrizeRewardStatus || (exports.PromoPrizeRewardStatus = PromoPrizeRewardStatus = {}));
var PromoPrizeRewardRefKey;
(function (PromoPrizeRewardRefKey) {
    PromoPrizeRewardRefKey["DRAW"] = "DRAW";
    PromoPrizeRewardRefKey["TICKET_ENTRY"] = "TICKET_ENTRY";
})(PromoPrizeRewardRefKey || (exports.PromoPrizeRewardRefKey = PromoPrizeRewardRefKey = {}));
var ReferralScheme;
(function (ReferralScheme) {
    ReferralScheme["GIVE12GET12"] = "GIVE12GET12";
    ReferralScheme["WINWITHFRIENDS"] = "WINWITHFRIENDS";
})(ReferralScheme || (exports.ReferralScheme = ReferralScheme = {}));
var ReferralStatus;
(function (ReferralStatus) {
    ReferralStatus["ACTIVE"] = "ACTIVE";
    ReferralStatus["INACTIVE"] = "INACTIVE";
})(ReferralStatus || (exports.ReferralStatus = ReferralStatus = {}));
//# sourceMappingURL=dbEnums.js.map